import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 工商信息字段映射表-查询-rzq
export const getTycMapReportList = (data) => {
    return request({
        url: apiCrmHost + '/dict/change/tyc/query/page',
        method: 'post',
        data
    });
};
// 工商信息字段映射表-保存-rzq
export const saveTycMapReportList = (data) => {
    return request({
        url: apiCrmHost + '/dict/change/tyc/save',
        method: 'post',
        data
    });
};
// 工商信息字段映射表-删除-rzq
export const deleteTycMapReportList = (data) => {
    return request({
        url: apiCrmHost + '/dict/change/tyc/del',
        method: 'post',
        data
    });
};
